export default __webpack_public_path__ + "static/media/EngineeringBridges_04.65969b4b.png";